module.exports = __webpack_public_path__ + "media/images/loghi/supercoppa-77167746e729110bec93e0a2e91f441e.jpeg";